import { Grid2, Typography } from "@mui/material";
import { useFormikContext } from "formik";
import React, { Fragment } from "react";
import BasicCoversheetInfoIco from "../../../../assets/icons/BasicCoversheetInfoIco";
import CompanyPreScreenIco from "../../../../assets/icons/ComapnyPreScreenIco";
import CommonAccordion from "../../../common-components/CommonAccordion";
import { CustomizeSpan } from "../../../jobs/style";
import MixedComponent from "../../components/MixedComponent";
import PreScreenQuestion from "../../components/PreScreenQuestion";
import References from "../../components/References";
import CommonButton from "../../../../component/Button";
import AddIcon from "@mui/icons-material/Add";
import AttachmentIco from "../../../../assets/icons/AttachmentIco";

export default function YourDetails({
  lg,
  expandedPanel,
  loading,
  handleChangeAccor,
  yourDetailsBasic,
  handleDeleteReferenceClick,
  view_resume,
  handleAddReference,
  form,
  enterDetails,
  coverSheet,
  attachmentUpload,
}) {
  const { values, errors, setFieldValue } = useFormikContext();

  return (
    <Fragment>
      <Typography variant={lg ? "h3" : "body5"} fontWeight={500}>
        Great{" "}
        <CustomizeSpan color="#FA4F96" fontWeight={700}>
          {coverSheet?.personal_details?.candidate_first_name}
        </CustomizeSpan>{" "}
      </Typography>
      <Typography
        variant={lg ? "h6" : "body1"}
        fontWeight={400}
        marginTop={"12px"}
        width={lg ? "60%" : "100%"}
      >
        We have received your resume through our recruitment partner, But we
        still need some additional details. I kindly request you to fill out the
        questions below
      </Typography>
      <Grid2 container spacing={2} marginTop={"1.5rem"}>
        <Grid2 size={12}>
          <CommonAccordion
            buttonborder={true}
            wholeborder="none"
            open={expandedPanel.includes("Basic Information")}
            onChange={handleChangeAccor("Basic Information")}
            title={"Basic Information"}
            icon={<BasicCoversheetInfoIco />}
            children={
              <Fragment>
                <Grid2 size={12} marginBottom={"1rem"}>
                  <Typography
                    variant={lg ? "h6" : "body1"}
                    color="#344054"
                    textOverflow={"ellipsis"}
                    whiteSpace={"nowrap"}
                    overflow={"hidden"}
                    margin={lg ? "0rem 0px 1rem" : "0rem 0px 0.5rem"}
                  >
                    {"1. Please enter your details."}
                  </Typography>

                  <MixedComponent editData={enterDetails} loading={loading} />
                </Grid2>

                <MixedComponent editData={yourDetailsBasic} loading={loading} />

                {/* <Grid2 size={12} marginTop={"1.5rem"}>
                  <MixedComponent editData={resumeUpload} loading={loading} />
                </Grid2> */}

                {/* <Grid2 size={12}>
                  <Typography
                    variant={lg ? "h6" : "subtitle3"}
                    color="#344054"
                    textOverflow={"ellipsis"}
                    whiteSpace={"nowrap"}
                    overflow={"hidden"}
                    margin={
                      values?.references?.length === 0
                        ? "1.5rem 0px 0px"
                        : "1.5rem 0px 1rem"
                    }
                  >
                    {"9. Add of your references."}
                    <CustomizeSpan color={"#079455"}> (Optional)</CustomizeSpan>
                  </Typography>

                  <References
                    data={values?.references || []}
                    values={values}
                    setFieldValue={setFieldValue}
                    loading={loading}
                    handleDeleteReferenceClick={handleDeleteReferenceClick}
                    disabled={loading || view_resume}
                  />
                  <CommonButton
                    margin={"1rem 0px 0px"}
                    value={"Add Reference"}
                    startIcon={<AddIcon />}
                    onClick={() => handleAddReference("references", form)}
                    padding={"10px 25px"}
                    gap={"0px"}
                    disabled={loading}
                    mobileFontSize={lg ? "14px" : "13px"}
                    fontWeight={700}
                    variant="outlined"
                  />
                </Grid2> */}
              </Fragment>
            }
          />
        </Grid2>

        <Grid2 size={12}>
          <CommonAccordion
            buttonborder={true}
            wholeborder="none"
            fontWeight={700}
            icon={<CompanyPreScreenIco />}
            title={"Add some References"}
            open={expandedPanel.includes("References")}
            onChange={handleChangeAccor("References")}
            children={
              <Fragment>
                <References
                  data={values?.references || []}
                  values={values}
                  setFieldValue={setFieldValue}
                  loading={loading}
                  handleDeleteReferenceClick={handleDeleteReferenceClick}
                  disabled={loading || view_resume}
                />
                <CommonButton
                  margin={"1rem 0px 0px"}
                  value={"Add Reference"}
                  startIcon={<AddIcon />}
                  onClick={() => handleAddReference("references", form)}
                  padding={"10px 25px"}
                  gap={"0px"}
                  disabled={loading}
                  mobileFontSize={lg ? "14px" : "13px"}
                  fontWeight={700}
                  variant="outlined"
                />
              </Fragment>
            }
          />
        </Grid2>

        {values.pre_screen_question_answers?.length !== 0 && (
          <Grid2 size={12}>
            <CommonAccordion
              buttonborder={true}
              wholeborder="none"
              fontWeight={700}
              icon={<CompanyPreScreenIco />}
              title={"What the company wants to know ?"}
              open={expandedPanel.includes("Pre-Screen Questions")}
              onChange={handleChangeAccor("Pre-Screen Questions")}
              children={
                <PreScreenQuestion
                  data={values.pre_screen_question_answers}
                  loading={loading}
                />
              }
            />
          </Grid2>
        )}

        <Grid2 size={12}>
          <CommonAccordion
            buttonborder={true}
            wholeborder="none"
            fontWeight={700}
            icon={<AttachmentIco />}
            title={"Attachments"}
            open={expandedPanel.includes("Attachments")}
            onChange={handleChangeAccor("Attachments")}
            children={
              <MixedComponent editData={attachmentUpload} loading={loading} />
            }
          />
        </Grid2>
      </Grid2>
    </Fragment>
  );
}
